export default class AuctionGuideController {
    constructor() {
        const element = document.querySelector('.c-auction-guide');

        if (element) {
            import(
                /* webpackChunkName: "AuctionGuide" */ '../classes/style/AuctionGuide'
            ).then(res => {
                const AuctionGuide = res.default;
                this.createInstance(AuctionGuide, element);
            });
        }
    }

    createInstance(AuctionGuide, element) {
        return new AuctionGuide(element);
    }
}

